import { render, staticRenderFns } from "./FavoriteClientList.vue?vue&type=template&id=85e73468&scoped=true&"
import script from "./FavoriteClientList.vue?vue&type=script&lang=js&"
export * from "./FavoriteClientList.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteClientList.vue?vue&type=style&index=0&id=85e73468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e73468",
  null
  
)

export default component.exports